import { phonesMatch } from './phoneMatch.utils';

type CentreView = {
  storeId: number;
  channel: string;
  contact: string;
};

let view: CentreView | null = null;

export const setCentreViewingThread = (next: CentreView | null) => {
  view = next;
};

const readData = (notification: { data?: unknown }) => {
  const raw = notification.data;
  if (!raw || typeof raw !== 'object') return {} as Record<string, unknown>;
  return raw as Record<string, unknown>;
};

export const isCentreNoticeForOpenThread = (notification: {
  type?: string;
  store_id?: number;
  data?: unknown;
}): boolean => {
  if (notification.type !== 'CENTRE_MESSAGE' || !view) return false;
  const data = readData(notification);
  const storeId = Number(data.storeId || data.store_id || notification.store_id);
  if (storeId && storeId !== view.storeId) return false;
  const channel = String(data.channel || 'whatsapp');
  if (channel !== view.channel) return false;
  const contact = String(data.contactId || data.contact || data.phone || '');
  if (!contact) return false;
  return channel === 'whatsapp'
    ? phonesMatch(contact, view.contact)
    : contact === view.contact;
};
